import { useEffect, useRef } from 'react';
import { useImmerReducer } from 'use-immer';

function withLogger(dispatch) {
  return function (action) {
    console.log('%cAction Type:%s', 'color: red;font-weight:"bold"', action.type, ' - PAYLOAD: ', action.payload);
    return dispatch(action);
  };
}

export default function useReducerWithLogger(...args) {
  const [state, dispatch] = useImmerReducer(...args);
  if (process.env.REACT_APP_ENV !== 'dev') {
    return [state, dispatch];
  }
  const { initData } = args;
  const prevState = useRef(initData);
  const dispatchWithLogger = withLogger(dispatch);
  useEffect(() => {
    if (state !== initData) {
      console.log('Prev state: ', prevState.current);
      console.log('Next state: ', state);
      prevState.current = state;
    }
  }, [state]);
  return [state, dispatchWithLogger];
}
